import { m } from "framer-motion";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { optimizedViewport } from "@/lib/motion";
import aboutImage from "@/assets/about-recycling.webp";

const About = () => {
  const { t } = useTranslation();
  const highlights = t("about.highlights", { returnObjects: true }) as string[];

  return (
    <section className="py-24 md:py-32 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent" />

      <div className="container mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <m.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={optimizedViewport} transition={{ duration: 0.6 }} className="relative">
            <div className="aspect-square rounded-3xl overflow-hidden border border-border">
              <img src={aboutImage} alt={t("about.imageAlt")} className="w-full h-full object-cover" decoding="async" />
            </div>
            <m.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={optimizedViewport} transition={{ duration: 0.6, delay: 0.3 }} className="absolute -bottom-6 -right-6 p-6 rounded-2xl glass glow-primary">
              <div className="font-heading text-4xl font-bold text-primary">{t("about.yearsValue")}</div>
              <div className="text-sm text-muted-foreground">{t("about.yearsLabel")}</div>
            </m.div>
          </m.div>

          <m.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={optimizedViewport} transition={{ duration: 0.6 }}>
            <span className="text-sm font-medium text-primary mb-4 block">{t("about.badge")}</span>
            <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold mb-6">
              {t("about.title")} <span className="text-gradient">{t("about.titleHighlight")}</span> {t("about.titleEnd")}
            </h2>
            <p className="text-muted-foreground text-lg mb-8">{t("about.text1")}</p>
            <p className="text-muted-foreground mb-8">{t("about.text2")}</p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {highlights.map((item, index) => (
                <m.li key={item} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={optimizedViewport} transition={{ duration: 0.4, delay: index * 0.05 }} className="flex items-center gap-3">
                  <div className="w-5 h-5 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-primary" />
                  </div>
                  <span className="text-sm">{item}</span>
                </m.li>
              ))}
            </ul>
          </m.div>
        </div>
      </div>
    </section>
  );
};

export default About;
